export const xs = "375"; // phone
export const small = "479";
export const medium = "767"; // medium tablet
export const large = "991"; // large tablet
export const xl = "1024"; // desktop

export const sizes = {xs: xs, small: small, medium: medium, large: large, xl: xl};